import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';

export const Method = {
    GET: 'GET',
    POST: 'POST'
};

export const fetchData = (url, requestBody, onSuccess, onGeneralError, method) => {
    fetchWithCSRF(Url.toAbsolute(url), {
        method: method || Method.POST,
        headers: new Headers({'Content-Type': 'application/json'}),
        body: requestBody ? JSON.stringify(requestBody) : null
    }).then((response) => {
        if (response.status === 403) {
            return {status: 'EXTERNAL_ERROR'};
        }
        return response.json();
    }).then(onSuccess)
        .catch((error) => {
            onGeneralError(error);
        });
};
